import React from 'react';
import { Star, Quote } from 'lucide-react';
import { businessData } from '../data/mock';

const Reviews = () => {
  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <Star
        key={index}
        size={16}
        className={`${
          index < rating
            ? 'fill-[var(--color-gold)] text-[var(--color-gold)]'
            : 'text-gray-300'
        }`}
      />
    ));
  };

  return (
    <section id="opiniones" className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-[var(--color-wine)] font-medium mb-2 tracking-wider uppercase text-sm">
            Testimonios
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-[var(--color-black)] mb-4">
            Lo que dicen nuestros clientes
          </h2>
          
          {/* Overall Rating */}
          <div className="flex items-center justify-center gap-4 mt-6">
            <div className="flex items-center gap-1">
              {renderStars(Math.round(businessData.rating))}
            </div>
            <div className="text-left">
              <p className="text-2xl font-bold text-[var(--color-black)]">
                {businessData.rating}
                <span className="text-base font-normal text-[var(--color-gray)]">/5</span>
              </p>
              <p className="text-sm text-[var(--color-gray)]">
                Basado en {businessData.totalReviews} opiniones de Google
              </p>
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {businessData.reviews.map((review, index) => (
            <div
              key={index}
              className="relative bg-[var(--color-cream)] rounded-xl p-6 md:p-8 shadow-sm hover:shadow-lg transition-shadow duration-300"
            >
              {/* Quote Icon */}
              <Quote
                size={40}
                className="absolute top-4 right-4 text-[var(--color-wine)]/10"
              />

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {renderStars(review.rating)}
              </div>

              {/* Review Text */}
              <p className="text-[var(--color-black)] leading-relaxed mb-6">
                "{review.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[var(--color-wine)] flex items-center justify-center">
                  <span className="text-[var(--color-cream)] font-semibold text-sm">
                    {review.author.charAt(0).toUpperCase()}
                  </span>
                </div>
                <div>
                  <p className="font-medium text-[var(--color-black)]">
                    {review.author}
                  </p>
                  <p className="text-xs text-[var(--color-gray)]">Google Maps</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Google Maps Link */}
        <div className="text-center mt-12">
          <a
            href={businessData.googleMapsReviewsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[var(--color-wine)] font-medium hover:text-[var(--color-wine-dark)] transition-colors"
          >
            Ver todas las opiniones en Google Maps
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
